import React from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import PropTypes from 'prop-types'
import AvatarUploader from 'forms/shared/uploader/avatar'
import uploadActions from 'actions/uploader/actions'

const AvatarField = ({ onDrop, src, initial, form }) => (
  <AvatarUploader
    accept="image/gif, image/jpeg, image/png"
    onDrop={files => onDrop({ target: form, files })}
    src={src} initial={initial} />
)

AvatarField.propTypes = {
  onDrop: PropTypes.func,
  src: PropTypes.string,
  initial: PropTypes.string,
  form: PropTypes.string,
}

const mapStateToProps = ({ auth, ...state }, { form }) => {
  const selector = formValueSelector(form)
  return {
    initial: auth.user.first_name ? auth.user.first_name.charAt(0) : 'X',
    src: selector(state, 'avatar'),
  }
}

const mapDispatchToProps = {
  onDrop: uploadActions.uploadingAvatar,
}

export default connect(mapStateToProps, mapDispatchToProps)(AvatarField)
